export enum IParcelTypes {
  Email = "Email",
  NotaEncrypted = "NotaEncrypted",
  EncryptedEDelivery = "EncryptedEDelivery",
  EDelivery = "EDelivery",
  ExternalEDelivery = "ExternalEDelivery",
  Puh = "Puh",
  Epuap = "Epuap",
  TraditionalLetter = "TraditionalLetter",

  CourtPortalDeliverance = "CourtPortalDeliverance",
  CourtPortalDocument = "CourtPortalDocument",
  Parcel = "Parcel",
  EDeliveryMessage = "EDeliveryMessage",
  CourtPortalApplication = "CourtPortalApplication",
  ContactMessage = "ContactMessage",
  OutgoingParcel = "OutgoingParcel",
  CourtPortalWriting = "CourtPortalWriting",
}
